<template>
  <nav>
    <div class="logo">
      <a href="/">
        <img src="../assets/webLogoNegro.svg" alt="" />
      </a>
    </div>
    <ul class="nav-links">
      <li><a href="/about">Conózcanos</a></li>
      <li><a href="/services">Nuestros servicios</a></li>
      <li><a href="/contact">Contáctenos</a></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "navBar",
};
</script>

<style lang="css" scoped>
nav {
  border-bottom: 1px solid #eee;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  padding: 10px 100px;
  box-sizing: border-box;
  transition: 0.5s;
  z-index: 100000;
}

nav .logo {
  float: left;
}

nav .logo img {
  height: 80px;
  transition: 0.5s;
  cursor: pointer;
}

nav ul {
  float: right;
  margin: 0;
  padding: 0;
  display: flex;
}

nav ul li {
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

nav ul li a {
  font-weight: bold;
  color: var(--textColor);
  line-height: 80px;
  padding: 5px 20px;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.5s;
}

nav ul li a:hover {
  text-decoration: none;
  color: var(--primary);
  border-bottom: 3px solid var(--primary);
}
@media (max-width: 1126px) {
  nav{
    padding: 10px 0;
  }
  nav .logo {
    
  }
  nav ul {
    
  }
}
</style>
